import { useMemo } from 'react';

import {
    Panel,
    React,
    Text,
    View
} from '../../common';
import { BackupItem } from './Backup/BackupList';

export const BackupSelector = ({
    onClick,
    isIos,
    selectedItem,
}) => {

    const title = useMemo(() => <BackupItem
        item={selectedItem}
        isIos={isIos}
        last={true}/>, [ selectedItem, isIos ]);

    return <View style={{ paddingHorizontal: 12 }}>
        <Panel
            style={[
                {
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: 8,
                    borderWidth: 1,
                    borderColor: '#E9E9E9',
                    borderRadius: 8,
                    backgroundColor: '#FFFFFF',
                },
            ]}
            onPress={() => {
                console.log('BackupSelector onPress');
                onClick?.();
            }}
            ns="navigator"
        >
            <View style={{
                flex: 1,
                flexDirection: 'column',
                alignItems: 'stretch',
            }}>
                {title}
            </View>
            <View style={{
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: 16,
            }}>
                <Text style={{
                    fontSize: 16,
                    color: '#c9c9c9',
                }}>›</Text>
            </View>
        </Panel>
    </View>;
};
